import React, { useEffect } from 'react';
import { DashboardLayout } from '../components/UI/Layout/DashboardLayout';
import LocationsComponent from 'components/Locations/LocationsComponent';

export const Locations: React.FC = () => {
    useEffect(() => {
        document.title = 'Locations - Organizations';
    }, []);

    return (
        <DashboardLayout>
            <LocationsComponent />
        </DashboardLayout>
    );
};

export default Locations;
